import React, { useRef } from "react";
import { Carousel } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

type CarouselCustomProps = {
  images: { src: string; alt: string }[];
  autoplaySpeed?: number;
};

export const CarouselCustom: React.FC<CarouselCustomProps> = ({
  images,
  autoplaySpeed = 3000,
}) => {
  const carouselRef = useRef<any>(null);

  const goToPrev = () => carouselRef.current?.prev();
  const goToNext = () => carouselRef.current?.next();

  const contentStyleC: React.CSSProperties = {
    width: "100%",
    height: "auto",
    objectFit: "cover",
  };

  return (
    <div style={{ position: "relative", margin: "0 auto" }}>
      <Carousel
        ref={carouselRef}
        autoplay
        autoplaySpeed={autoplaySpeed}
        dots
        infinite
      >
        {images.map((image) => (
          <div key={image.src}>
            <img src={image.src} alt={image.alt} style={contentStyleC} />
          </div>
        ))}
      </Carousel>

      {/* Botón Izquierda */}
      <button
        onClick={goToPrev}
        style={{
          position: "absolute",
          top: "50%",
          left: "16px",
          transform: "translateY(-50%)",
          background: "rgba(0,0,0,0.5)",
          border: "none",
          color: "white",
          width: "40px",
          height: "40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "50%",
          cursor: "pointer",
        }}
      >
        <LeftOutlined style={{ fontSize: "18px" }} />
      </button>

      {/* Botón Derecha */}
      <button
        onClick={goToNext}
        style={{
          position: "absolute",
          top: "50%",
          right: "16px",
          transform: "translateY(-50%)",
          background: "rgba(0,0,0,0.5)",
          border: "none",
          color: "white",
          width: "40px",
          height: "40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "50%",
          cursor: "pointer",
        }}
      >
        <RightOutlined style={{ fontSize: "18px" }} />
      </button>
    </div>
  );
};